import React, { useState } from "react";
import { FaUserGraduate } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { createPortal } from "react-dom";
import axios from "axios";

const ClientActiveStatusModal = ({ client, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Approve Client
  const handleApprove = async () => {
    if (!client?._id) return;
    setLoading(true);
    setErrorMsg("");

    const url = `${process.env.REACT_APP_API_URL}/our-client/approve-client/${client._id}`;

    try {
      const response = await axios.put(url);
      console.log("Approved response:", response.data);
      onClose();
    } catch (error) {
      console.error("Approve error:", error);
      setErrorMsg("Failed to approve the client.");
    } finally {
      setLoading(false);
    }
  };

  // suspended client
  const handleInactive = async () => {
    if (!client?._id) return;
    setLoading(true);
    setErrorMsg("");

    const url = `${process.env.REACT_APP_API_URL}/our-client/change-client-status/${client._id}`;
    const payload = { status: "suspended" };

    try {
      const response = await axios.put(url, payload, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Inactive response:", response.data);
      onClose();
    } catch (error) {
      console.error("Inactive error:", error);
      setErrorMsg("Failed to mark client as inactive.");
    } finally {
      setLoading(false);
    }
  };

  // Active Client
  const handleActive = async () => {
    if (!client?._id) return;
    setLoading(true);
    setErrorMsg("");

    const url = `${process.env.REACT_APP_API_URL}/our-client/active-client/${client._id}`;

    try {
      const response = await axios.put(url);
      console.log("Approved response:", response.data);
      onClose();
    } catch (error) {
      console.error("Approve error:", error);
      setErrorMsg("Failed to approve the client.");
    } finally {
      setLoading(false);
    }
  };

  // Withdrawal Client
  const handleWithdrawal = async () => {
    if (!client?._id) return;
    setLoading(true);
    setErrorMsg("");

    const url = `${process.env.REACT_APP_API_URL}/our-client/withdrawal-client/${client._id}`;
    const payload = { status: "withdrawal" };

    try {
      const response = await axios.put(url, payload, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Inactive response:", response.data);
      onClose();
    } catch (error) {
      console.error("Inactive error:", error);
      setErrorMsg("Failed to mark client as inactive.");
    } finally {
      setLoading(false);
    }
  };

  const displayName = client?.name || client?.clientName || "this client";

  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="max-w-md w-full bg-white shadow-xl rounded-xl overflow-hidden mx-auto">
        {/* Header */}
        <div className="py-1 bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] shadow-lg relative">
          <h2 className="text-center text-base sm:text-xl md:text-2xl lg:text-2xl font-normal p-2 text-white">
            Client Approval
          </h2>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            aria-label="Close modal"
          >
            <AiOutlineClose className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 flex flex-col items-center text-center gap-5">
          <FaUserGraduate className="w-24 h-24 text-[#1B81B2] bg-gray-100 rounded-full p-2 border-4 border-white shadow-md" />

          <p className="w-4/5 text-gray-700 text-base sm:text-lg font-medium">
            Are you sure you want to approve{" "}
            <span className="font-semibold text-[#1B81B2]">{displayName}</span>?
          </p>

          {errorMsg && (
            <p className="text-red-500 text-sm font-medium">{errorMsg}</p>
          )}

          {/* Buttons */}
          <div className="flex justify-center gap-2 w-full">
            <button
              disabled={loading}
              onClick={handleWithdrawal}
              className="flex-1 py-2 rounded-lg text-white bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] transition duration-200 shadow-md text-sm sm:text-base font-medium disabled:opacity-50"
            >
              {loading ? "Processing..." : "Withdrawal"}
            </button>
            <button
              disabled={loading}
              onClick={handleInactive}
              className="flex-1 py-2 rounded-lg text-white bg-gradient-to-r from-[#ff4d4f] to-[#d32f2f] hover:opacity-90 transition duration-200 shadow-md text-sm sm:text-base font-medium disabled:opacity-50"
            >
              {loading ? "Processing..." : "Suspended"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ClientActiveStatusModal;
